import { render, staticRenderFns } from "./SubmissionFormModal.vue?vue&type=template&id=691015a0&scoped=true&"
import script from "./SubmissionFormModal.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691015a0",
  null
  
)

export default component.exports